import React, { ReactNode, useContext, useState, useEffect } from 'react';
import { NavLink, useLocation, useNavigate, Link } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { User, UserMode } from '../types';
import { Breadcrumbs } from './common';
import { getTraineeProfile } from '../services/AuthService';
import { getImageUrl } from '../services/imagePathConfig';

// Icons
// FIX: Updated all icon components to accept props to fix a type error.
const DashboardIcon = (props: React.ComponentProps<'svg'>) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg>;
const ProfileIcon = (props: React.ComponentProps<'svg'>) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>;
const CoursesIcon = (props: React.ComponentProps<'svg'>) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c0 1.7 2.7 3 6 3s6-1.3 6-3v-5"></path></svg>;
const CertificateIcon = (props: React.ComponentProps<'svg'>) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M12 15l-3.5-3.5a2.5 2.5 0 1 1 3.5-3.5V15z"></path><path d="M12 15l3.5-3.5a2.5 2.5 0 1 0-3.5-3.5V15z"></path><path d="M12 3v2"></path><path d="M6.5 5.5l-1.4 1.4"></path><path d="M17.5 5.5l1.4 1.4"></path><circle cx="12" cy="12" r="7"></circle></svg>;
const QuizIcon = (props: React.ComponentProps<'svg'>) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>;
const OrderHistoryIcon = (props: React.ComponentProps<'svg'>) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>;
const ReferralsIcon = (props: React.ComponentProps<'svg'>) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line></svg>;
const SupportIcon = (props: React.ComponentProps<'svg'>) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>;
const LogoutIcon = (props: React.ComponentProps<'svg'>) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>;
const MenuIcon = (props: React.ComponentProps<'svg'>) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>;
const BellIcon = (props: React.ComponentProps<'svg'>) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>;
const ChevronDownIcon = (props: React.ComponentProps<'svg'>) => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><polyline points="6 9 12 15 18 9"></polyline></svg>;
const KanbanIcon = (props: React.ComponentProps<'svg'>) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="3" x2="9" y2="21"></line><line x1="15" y1="3" x2="15" y2="21"></line></svg>;
const ScheduleIcon = (props: React.ComponentProps<'svg'>) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg>;
const AttendanceIcon = (props: React.ComponentProps<'svg'>) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><polyline points="17 11 19 13 23 9"></polyline></svg>;
const FeedbackIcon = (props: React.ComponentProps<'svg'>) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" {...props}><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path></svg>;


// const EdjamonLogo = () => (
//     <div className="flex items-center justify-center p-4 h-16 border-b border-gray-700">
//          <Link to="/dashboard" className="flex items-center gap-2">
//             <h1 className="text-2xl font-black text-red-500 relative">
//                 <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 absolute -top-4 -left-1 text-red-500" viewBox="0 0 24 24" fill="currentColor">
//                     <path d="M5 16L3 5l5.5 5L12 4l3.5 6L21 5l-2 11H5z"></path>
//                 </svg>
//                 E<span className="text-secondary">d</span>JAMON
//             </h1>
//         </Link>
//     </div>
// );

const EdjamonLogo = () => (
    <div className="flex justify-center items-center">
        <img
            src="/logo/EdJAMON.png"
            alt="EdJAMON Logo"
            className="h-12 w-auto object-contain"
        />
    </div>
);


const allNavItems = [
    { path: '/dashboard', label: 'Dashboard' },
    { path: '/courses', label: 'My Registrations' },
    { path: '/profile', label: 'My Profile' },
    { path: '/certificates', label: 'Certificate Generator' },
    { path: '/wishlist', label: 'Placements' },
    { path: '/reviews', label: 'Analytics' },
    { path: '/quiz-attempts', label: 'Mock Interview' },
    { path: '/order-history', label: 'All Candidates' },
    { path: '/referrals', label: 'Create Batch Page' },
    { path: '/messages', label: 'Direct Enquiries' },
    { path: '/support-tickets', label: 'Social Media Enquiries' },
    { path: '/settings', label: 'Assign Candidates' },
    { path: '/kanban', label: 'Kanban Board' },
    { path: '/schedule', label: 'My Schedule' },
    { path: '/attendance', label: 'Attendance' },
    { path: '/feedback', label: 'Feedback' },
    { path: '/alumni', label: 'Our Alumni' },
];

const Sidebar: React.FC<{ isSidebarOpen: boolean, setSidebarOpen: (isOpen: boolean) => void, mode: UserMode }> = ({ isSidebarOpen, setSidebarOpen, mode }) => {
    const auth = useContext(AuthContext);
    const navigate = useNavigate();

    const handleLogout = () => {
        if (auth) {
            auth.logout();
            navigate('/auth/login');
        }
    };

    // FIX: Correctly type the `icon` prop to allow passing a `className` via `React.cloneElement`.
    const NavItem: React.FC<{ to: string; icon: React.ReactElement<any>; children: ReactNode }> = ({ to, icon, children }) => (
        <NavLink
            to={to}
            className={({ isActive }) =>
                `flex items-center px-4 py-2.5 text-xs sm:text-sm font-medium rounded-md transition-colors ${isActive ? 'bg-primary-500/10 text-primary' : 'text-gray-400 hover:text-white hover:bg-gray-700'
                }`
            }
            onClick={() => setSidebarOpen(false)}
        >
            {React.cloneElement(icon, { className: "w-5 h-5" })}
            <span className="ml-3 truncate">{children}</span>
        </NavLink>
    );

    const onlineNavItems = [
        { path: '/dashboard', label: 'Dashboard', icon: <DashboardIcon /> },
        { path: '/courses', label: 'My Registrations', icon: <CoursesIcon /> },
        { path: '/profile', label: 'My Profile', icon: <ProfileIcon /> },
        { path: '/certificates', label: 'Certificate Generator', icon: <CertificateIcon /> },
        { path: '/wishlist', label: 'Placements', icon: <CoursesIcon /> },
        { path: '/reviews', label: 'Analytics', icon: <CoursesIcon /> },
        { path: '/quiz-attempts', label: 'Mock Interview', icon: <QuizIcon /> },
        { path: '/order-history', label: 'All Candidates', icon: <OrderHistoryIcon /> },
        { path: '/referrals', label: 'Create Batch Page', icon: <ReferralsIcon /> },
        { path: '/messages', label: 'Direct Enquiries', icon: <CoursesIcon /> },
        { path: '/support-tickets', label: 'Social Media Enquiries', icon: <SupportIcon /> },
        { path: '/settings', label: 'Assign Candidates', icon: <CoursesIcon /> },
    ];

    const offlineNavItems = [
        { path: '/dashboard', label: 'Dashboard', icon: <DashboardIcon /> },
        { path: '/kanban', label: 'Kanban Board', icon: <KanbanIcon /> },
        { path: '/schedule', label: 'My Schedule', icon: <ScheduleIcon /> },
        { path: '/attendance', label: 'Attendance', icon: <AttendanceIcon /> },
        // { path: '/feedback', label: 'Feedback', icon: <FeedbackIcon /> },
        { path: '/profile', label: 'My Profile', icon: <ProfileIcon /> },
        { path: '/alumni', label: 'Our Alumni', icon: <AttendanceIcon /> },
    ];

    const navItems = mode === 'online' ? onlineNavItems : offlineNavItems;

    return (
        <aside className={`fixed inset-y-0 left-0 bg-gray-800 text-white z-50 w-64 transform ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} transition-transform duration-300 ease-in-out md:relative md:translate-x-0 md:flex md:flex-col`}>
            <EdjamonLogo />
            <nav className="flex-1 px-3 sm:px-4 py-4 sm:py-6 space-y-1">
                {navItems.map(item => (
                    <NavItem key={item.path} to={item.path} icon={item.icon}>
                        {item.label}
                    </NavItem>
                ))}
            </nav>
            <div className="px-3 sm:px-4 py-3 sm:py-4 border-t border-gray-700">
                <button onClick={handleLogout} className="flex items-center w-full px-3 sm:px-4 py-2 sm:py-2.5 text-xs sm:text-sm font-medium text-gray-400 rounded-md hover:text-white hover:bg-gray-700 truncate">
                    <LogoutIcon className="flex-shrink-0" />
                    <span className="ml-3 truncate">Logout</span>
                </button>
            </div>
        </aside>
    );
};

const Header: React.FC<{ setSidebarOpen: (isOpen: boolean) => void; }> = ({ setSidebarOpen }) => {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [profileData, setProfileData] = useState<any>(null);
    const [loading, setLoading] = useState(false);
    const auth = useContext(AuthContext);
    const user = auth?.currentUser;
    const navigate = useNavigate();
    const traineeToken = localStorage.getItem('TraineeToken');

    // Fetch trainee profile from API
    useEffect(() => {
        const fetchProfile = async () => {
            if (!auth?.currentUser?.id) {
                return;
            }
            console.log("Current user", auth);

            setLoading(true);
            try {
                // Get the token - you might need to adjust this based on your auth structure
                const token = (auth.currentUser as any)?.token ||
                    (auth.currentUser as any)?.TraineeToken ||
                    localStorage.getItem('authToken') ||
                    auth.currentUser.id;

                console.log('Fetching profile with token:', token);

                // Call the API
                const response = await getTraineeProfile(traineeToken);
                console.log('Profile API response:', response);

                if (response.success) {
                    setProfileData(response.data);
                }
            } catch (error) {
                console.error('Error fetching trainee profile:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchProfile();
    }, [auth?.currentUser?.id]);

    const handleLogout = () => {
        if (auth) {
            auth.logout();
            navigate('/auth/login');
        }
    };

    // Use the name from API if available, otherwise use basic user data
    const displayName = profileData
        ? profileData.basicInfo?.fullName
        : `${user?.firstName} ${user?.lastName}`;

    const enrollId = profileData?.basicInfo?.enrollId;

    const profilePicture = profileData?.profileDetail?.profilePicture || profileData?.basicInfo?.profile;
    const avatarUrl = getImageUrl(profilePicture) || user?.avatar;

    const initials = displayName
        .split(' ')
        .map((n: string) => n[0])
        .join('')
        .slice(0, 2)
        .toUpperCase() || 'U';

    return (
        <header className="flex-shrink-0 bg-white border-b border-gray-200">
            <div className="flex items-center justify-between p-3 sm:p-4 h-14 sm:h-16 gap-2">
                <div className="flex items-center gap-2 sm:gap-4 flex-1 min-w-0">
                    <button onClick={() => setSidebarOpen(true)} className="text-gray-500 md:hidden flex-shrink-0">
                        <MenuIcon />
                    </button>
                    <div className="flex-1 min-w-0 overflow-hidden">
                        <Breadcrumbs allNavItems={allNavItems} />
                    </div>
                </div>
                <div className="flex items-center gap-2 sm:gap-4 flex-shrink-0">
                    <div className="relative">
                        <button
                            onClick={() => setDropdownOpen(!dropdownOpen)}
                            className="flex items-center gap-1 sm:gap-2 min-w-0"
                        >
                            <div className="h-8 sm:h-9 w-8 sm:w-9 rounded-full overflow-hidden flex-shrink-0">
                                {avatarUrl ? (
                                    <img
                                        src={avatarUrl}
                                        alt="avatar"
                                        className="h-full w-full object-cover"
                                    />
                                ) : (
                                    <div className="h-full w-full bg-primary-600 text-white flex items-center justify-center font-bold text-xs sm:text-sm">
                                        {initials}
                                    </div>
                                )}
                            </div>
                            <div className="hidden sm:block text-left min-w-0">
                                <div className="text-sm font-semibold text-gray-800 truncate">
                                    {loading ? 'Loading...' : displayName}
                                </div>
                                <div className="text-xs text-gray-500 capitalize truncate">
                                    {user?.mode} Student
                                    {enrollId && ` • ${enrollId}`}
                                </div>
                            </div>
                            <ChevronDownIcon className="flex-shrink-0 hidden sm:block" />
                        </button>
                        {dropdownOpen && (
                            <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-20">
                                <Link to="/profile" onClick={() => setDropdownOpen(false)} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">My Profile</Link>
                                <button onClick={handleLogout} className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100">Logout</button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </header>
    );
};
export const Layout: React.FC<{ children: ReactNode; userMode: UserMode }> = ({ children, userMode }) => {
    const [isSidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className="flex h-screen bg-gray-100">
            {isSidebarOpen && <div onClick={() => setSidebarOpen(false)} className="fixed inset-0 bg-black/50 z-40 md:hidden"></div>}

            <Sidebar isSidebarOpen={isSidebarOpen} setSidebarOpen={setSidebarOpen} mode={userMode} />
            <div className="flex-1 flex flex-col overflow-hidden">
                <Header setSidebarOpen={setSidebarOpen} />
                <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-100 p-3 sm:p-4 md:p-6">
                    {children}
                </main>
            </div>
        </div>
    );
};

